import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { App } from './app/App'
/* Theme tokens precede the shared component styles. */
import './design/theme-afra.css'
import './design/base.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // A charity's belief state does not change behind their back, so
      // refetching on every window focus is noise and, behind a slow
      // connection, a visible stall.
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30_000,
    },
  },
})

const root = document.getElementById('root')
if (!root) throw new Error('#root is missing from index.html')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </QueryClientProvider>
  </StrictMode>,
)
